export default __webpack_public_path__ + "static/media/green-outer.1f42f67e.svg";